import { Variant } from "../../types/types";
import { isFutureRelease } from "./isFutureRelease";

export function isAvailableToPreOrder(variant: Variant) {
  return !!variant.availability?.preOrder && !isFutureRelease(variant);
}
